import _map from "lodash.map";
import _sortby from "lodash.sortby";
import { splitIndexKey } from "@/commons/util.js"


export const getFilterOptions = function ({ metadata, searchResponse, categoryName = "Categories" }) {
    let tempCategories = _map(searchResponse.aggregations.sent.filter_sent.categories.buckets, ({ doc_count, key }) => {
        return { ...splitIndexKey(key), freq: doc_count };
    });
    console.log(metadata);
    // if (metadata?.categories?.global_frequencies) {
    //     tempCategories = [];
    //     Object.keys(metadata.categories.global_frequencies).forEach(category => {
    //         tempCategories.push({ ...splitIndexKey(category), freq: metadata.categories.global_frequencies[category] });
    //     });
    // }
    const tempCategoriesSorted = _sortby(tempCategories,
        function (o) { return -o.freq; }
    );
    console.log(tempCategoriesSorted);

    let tempEntities = _map(searchResponse.aggregations.sent.filter_sent.entities.buckets, ({ doc_count, key }) => {
        return { ...splitIndexKey(key), freq: doc_count };
    });

    let tempPolarities = _map(searchResponse.aggregations.sent.filter_sent.polarity.buckets, ({ doc_count, key }) => {
        return { ...splitIndexKey(key), type: "POLARITY", freq: doc_count };
    });

    return {
        categoryName: categoryName,
        categories: Object.freeze(tempCategoriesSorted),
        entities: Object.freeze(tempEntities.slice(0, 10)),
        polarities: Object.freeze(tempPolarities)
    };
};
